export default "__VITE_ASSET__UF4iDpNJhIbRdkaNqmNRqw__"